import ZVideo from './ZVideo.vue'
export default ZVideo
